import React from 'react';
import { HStack, VStack } from '@televet/kibble-ui/build/chakra';
import { Icon, IconName } from '@televet/kibble-ui/build/components/Icon';
import { Text } from '@televet/kibble-ui/build/components/Text';

interface InfoProps {
  iconName: IconName;
  label: string;
  value: string | number;
}

export const AppointmentInfo = ({ iconName, label, value }: InfoProps): JSX.Element => (
  <HStack spacing={2} alignItems="flex-start">
    <Icon variant="subtle" name={iconName} size="lg" p={1} />
    <VStack spacing={0} align="flex-start">
      <Text as="p" size="sm" variant="subtle">
        {label}
      </Text>
      <Text as="p" size="md" whiteSpace="pre-wrap">
        {value}
      </Text>
    </VStack>
  </HStack>
);
